import { render, staticRenderFns } from "./ConfirmRemovingDocumentModal.vue?vue&type=template&id=068d46d8"
import script from "./ConfirmRemovingDocumentModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmRemovingDocumentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('068d46d8')) {
      api.createRecord('068d46d8', component.options)
    } else {
      api.reload('068d46d8', component.options)
    }
    module.hot.accept("./ConfirmRemovingDocumentModal.vue?vue&type=template&id=068d46d8", function () {
      api.rerender('068d46d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/ConfirmRemovingDocumentModal.vue"
export default component.exports